import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import styles from './styles.css';

const DefSubListItem = ({
  className,
  title,
  data,
  dataTestHandle,
}) => (
  <div className={classNames(styles.listItem, className)} data-test-handle={dataTestHandle}>
    <span className={styles['listItem-title']}>{title}</span>
    <span className={styles['listItem-data']}>{data}</span>
  </div>
);

DefSubListItem.propTypes = {
  title: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
  data: PropTypes.oneOfType([PropTypes.string, PropTypes.number, PropTypes.object]),
  className: PropTypes.string,
  dataTestHandle: PropTypes.string,
};

DefSubListItem.defaultProps = {
  title: '',
  data: '',
  className: '',
  dataTestHandle: '',
};

export default DefSubListItem;



// WEBPACK FOOTER //
// ./src/components/DefSubList/index.js